(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    
$(document).ready(function(){$(function(){$("#accordion").find(".accordion-toggle").click(function(){$(this).next().slideToggle(300),$(".accordion-content").not($(this).next()).slideUp(300)})})});

  } catch(e) { console.error(e); }
})();
})();
